import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(undefined);

  useEffect(() => {
    const token = localStorage.getItem("gh-admin-token");
    if (!token) {
      setAdmin(null);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("gh-admin-token");
        setAdmin(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("gh-admin-token", data.token);
    setAdmin(data.user);
  };

  const logout = () => {
    localStorage.removeItem("gh-admin-token");
    setAdmin(null);
  };

  const authHeader = () => {
    const token = localStorage.getItem("gh-admin-token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
